import { render, staticRenderFns } from "./AttributeBar.vue?vue&type=template&id=875ff866&scoped=true"
import script from "./AttributeBar.vue?vue&type=script&lang=js"
export * from "./AttributeBar.vue?vue&type=script&lang=js"
import style0 from "./AttributeBar.vue?vue&type=style&index=0&id=875ff866&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ff866",
  null
  
)

export default component.exports